<template>
    <div style="height: 100vh;width: 100vw;background-color: #f5f7fa;display: flex;">
        <!-- 左侧表格 -->
        <div class="left_table" style="width:260px;border-right: 1px solid #e4e7ed;padding: 10px;overflow-y: auto;">
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <h3 style="margin-bottom: 10px;">上传图片列表</h3>
                <el-button type="primary" size="mini" icon="el-icon-refresh" @click="refresh"></el-button>
            </div>
            <el-table  height="calc(100vh - 150px)" :data="leftTableDataList" size="mini" style="width: 100%" @row-click="handleLeftRowClick">
                <el-table-column label="选择" width="55">
                    <template slot-scope="scope">
                        <el-radio v-if="scope.row.state == 1" v-model="selectedRowId" :label="scope.row.id"></el-radio>
                        <el-link v-else type="primary" :underline="false" size="mini">识别中</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="fileUrl" label="商品图片" show-overflow-tooltip width="60">
                    <template slot-scope="scope">
                        <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                            <el-image v-if="scope.row.fileUrl" style="width: 25px; height: 25px" :src="scope.row.fileUrl" fit="contain" :preview-src-list="[scope.row.fileUrl]"></el-image>
                            <span v-else>无图片</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="uploadTime" label="上传时间">
                    <template slot-scope="scope">
                        <span style="white-space: normal; word-break: break-all;">{{$common.getLocalTime(scope.row.uploadTime,true) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click.stop="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div style="margin-top: 10px;">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="getRequestData.rows"
                    :current-page="getRequestData.page"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    size="small"
                />
            </div>
        </div>
        <!-- 右侧内容 -->
        <div style="flex: 1;overflow-y: auto;">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div>
                                    <el-form label-width="220px" id="mainInfo" class="baseForm" :model="rightfromData" ref="rightfromData" size="mini" :show-message="false">
                                        <div :class="{'rightHeight':type == 0,'rightHeight1':type == 1}" style="overflow-y: auto;overflow-x: auto;">
                                            <el-row>
                                                <template v-for="(value, key) in rightfromData">
                                                    <el-form-item :label="key" :key="key">
                                                        <label slot="label">{{ key }}:</label>
                                                        <!-- 处理 matchedGoods 数组 -->
                                                        <div v-if="key === 'matchedGoods' && value">
                                                            <div v-for="(item, index) in JSON.parse(value)" :key="index" style="margin-bottom: 10px; padding: 5px; border: 1px solid #e4e7ed; border-radius: 4px;">
                                                                <div v-for="(goodsValue, goodsKey) in item" :key="goodsKey">
                                                                    <span style="font-weight: bold;">{{ goodsKey }}:</span> {{ goodsValue }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- 可编辑字段 -->
                                                        <el-input v-else-if="editableDataList.includes(key)" v-model="rightfromData[key]" size="mini"></el-input>
                                                        <!-- 不可编辑字段 -->
                                                        <el-input v-else v-model="rightfromData[key]" size="mini" :disabled="true"></el-input>
                                                    </el-form-item>
                                                </template>
                                            </el-row>
                                        </div>
                                    </el-form>
                                    <div id="operateBtn">
                                        <el-button v-if="type == 0" type="primary" size="mini" @click="importOcrResult">导入匹配</el-button>
                                        <el-button v-else type="primary" size="mini" @click="importCustomer">导入匹配</el-button>
                                    </div>
                                    <!-- 操作按钮 -->
                                    <div style="height: calc(100vh - 250px);" v-if="type == 0">
                                        <el-form :inline="true" size="mini">
                                            <!-- 商品明细表格 -->

                                            <el-table v-if="pageShowData.jurTableVo" size="mini" stripe :data="sysBasicsgoodList" border style="width: 100%" height="300" :key="$store.state.tableNum"
                                                    highlight-current-row>
                                                <el-table-column fixed="left" label="操作" width="110" align="center">
                                                    <template slot-scope="scope">
                                                    <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
                                                    </template>
                                                </el-table-column>
                                                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                                                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" show-overflow-tooltip :label="tableValye.showField">
                                                        <template slot-scope="scope">
                                                            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                                                            <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}</span>
                                                            <span v-else-if="tableValye.isRift == 1">
                                                                {{ scope.row[tableValye.entityField] }}
                                                            </span>
                                                            <span v-else-if="tableValye.entityField == 'bgmActivestatus'">{{ $store.state.businessGoodsState[scope.row.bgmActivestatus].name }}</span>
                                                            <el-tag size="mini" v-else-if="tableValye.entityField == 'ggmState'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.ggmState) }}</el-tag>
                                                            <el-tag size="mini" v-else-if="tableValye.entityField == 'goodType'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.goodType) }}</el-tag>
                                                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                                        </template>
                                                    </el-table-column>
                                                </template>
                                            </el-table>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" @initActionBox="initActionBox" @sendDataAction="sendDataAction"></v-foot>
            </div>
        </div>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "matchGSPgoods",
    components: {
        SearchScheme,
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        pageShowData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seIndex: 0,
            seType: "",
            parentSearchData: {},
            sField: "",
            fField: "",
            getRequestData: {
                page: 1,
                rows:20,
            },
            imgUrl: "",
            rightfromData: {},
            leftTableDataList: [],
            // 单选
            selectedRowId: null,
            sysBasicsgoodList: [],
            // 分页
            total: 0,
            //可编辑数据
            editableDataList: ['药品通用名称', '药品批准文号', '规格', '包装规格', '产品名称', '注册证编号','名称','统一社会信用代码']
        };
    },
    methods: {
        // 刷新左侧表格
        refresh() {
            this.GSPgoodsQueryOcrResultList();
        },
        sendDataAction(data) {
            this.$emit('drawerCancel');
            console.log(data,'发送的数据');
        },
        // 选择商品跳转到表单
        handleSelectClick(row) {
            let dataInfo = row;
            console.log(dataInfo,'选择的商品11111111111');
            this.$emit('handleSelectClick', dataInfo,this.rightfromData,this.selectedRowId);
            console.log(row,this.type,'选择的商品');
        },
        imgurl() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 左侧表格行点击事件
        handleLeftRowClick(row) {
            // 处理左侧表格行点击
            console.log('左侧表格行点击:', row);
            this.sysBasicsgoodList=[]
            // 设置选中行ID，使单选按钮显示为选中状态
            this.selectedRowId = row.id;
            // 解析 JSON 字符串为对象
            if (row.ocrContent) {
                try {
                    let parsedData = JSON.parse(row.ocrContent);
                    // 删除指定字段
                    delete parsedData['主送'];
                    delete parsedData['抄送'];
                    delete parsedData['审批结论'];
                    let priorityFields = [];
                    // 调整字段顺序，将指定字段移到最前面
                    if(this.type == 0){
                        if(parsedData['标题'] && parsedData['标题'].includes('器械')){
                            priorityFields = ['产品名称', '注册证编号', '包装规格'];
                        }else{
                            priorityFields = ['药品通用名称', '药品批准文号', '规格'];
                        }
                    }else{
                        priorityFields = ['名称', '统一社会信用代码'];
                    }

                    let orderedData = {};
                    
                    // 先添加优先级字段
                    priorityFields.forEach(field => {
                        if (parsedData[field]) {
                            orderedData[field] = parsedData[field];
                            delete parsedData[field];
                        }else{
                            orderedData[field] = '';
                        }
                    });
                    
                    // 添加剩余字段
                    for (let key in parsedData) {
                        orderedData[key] = parsedData[key];
                    }
                    
                    this.rightfromData = orderedData;
                } catch (e) {
                    console.log('JSON 解析错误:', e);
                    this.rightfromData = {};
                }
            } else {
                this.rightfromData = {};
            }
            // 可以在这里实现将左侧商品添加到右侧表格的逻辑
        },
        importCustomer(){
            if (Object.keys(this.rightfromData).length != 0) {
                this.handleSelectClick(this.rightfromData);
            }else{
                this.$message({
                    message: '请先选中商品信息',
                    type: 'error'
                });
            }
            
        },
        //导入识别
        async importOcrResult() {
            let data = {
                    bgiAppnumber: this.rightfromData['药品批准文号'] || this.rightfromData['注册证编号'],
                    bgmName: this.rightfromData['药品通用名称'] || this.rightfromData['产品名称'],
                    spec: this.rightfromData['规格'] || this.rightfromData['包装规格'],
                    taskId: this.selectedRowId
            }
            if (!data.bgiAppnumber) { 
                this.$message({
                    message: '请输入药品批准文号或注册证编号',
                    type: 'error'
                });
                return;
            }
            if (!data.bgmName) { 
                this.$message({
                    message: '请输入药品通用名称或产品名称',
                    type: 'error'
                });
                return;
            }
            if (!data.spec) { 
                this.$message({
                    message: '请输入规格或包装规格',
                    type: 'error'
                });
                return;
            }
            const responseData = await this.$http.GSPgoodsMatchResult(data)
            if (responseData.status == 200) {

                this.sysBasicsgoodList = responseData.result;
                // 处理 null 和 undefined 值为空字符串
                if (this.sysBasicsgoodList && Array.isArray(this.sysBasicsgoodList)) {
                    this.sysBasicsgoodList = this.sysBasicsgoodList.map(item => {
                        const processedItem = {};
                        for (let key in item) {
                            processedItem[key] = (item[key] === null || item[key] === undefined) ? '' : item[key];
                        }
                        return processedItem;
                    });
                }
                console.log(this.sysBasicsgoodList, '处理后的数据');
                if (this.sysBasicsgoodList.length == 0) {
                    this.$message({
                        message: '未查询到匹配商品信息',
                        type: 'error'
                    });
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 分页大小变化
        handleSizeChange(val) {
            this.getRequestData.rows = val;
            this.GSPgoodsQueryOcrResultList();
        },
        // 页码变化
        handleCurrentChange(val) {
            this.getRequestData.page = val;
            this.GSPgoodsQueryOcrResultList();
        },
        // 查询GSP商品详情
        async GSPgoodsQueryOcrResultList() {
            this.getRequestData.type = this.type;
            const responseData = await this.$http.GSPgoodsQueryOcrResultList(this.getRequestData)
            if (responseData.status == 200) {
                this.leftTableDataList = responseData.result.list;
                this.total = responseData.result.total; // 设置总条数
                this.leftTableDataList.forEach(item => {
                    item.fileUrl = this.imgUrl + "/" + item.fileUrl;
                });
                
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 删除识别商品任务
        handleDelete(row) {
            this.selectedRowId = row.id;
            this.GSPgoodsDeleteTask();
        },
        async GSPgoodsDeleteTask() {
            const responseData = await this.$http.GSPgoodsDeleteTask({
                ids: [this.selectedRowId]
            })
            if (responseData.status == 200) {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                if (!this.imgUrl) {
                    this.imgurl();
                }
                this.GSPgoodsQueryOcrResultList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 打开检索方案
        openSearch(sId, index, type, sField, fField, isTable) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            
            if (isTable && this.sendDataInfo.detailList[index]) {
                this.parentSearchData[type] = this.sendDataInfo.detailList[index][type];
            } else {
                this.parentSearchData[type] = this.sendDataInfo[type];
            }
        },
        // 处理检索结果
        changeInputModel(val) {
            if (!val) return;
            
            if (this.seType === 'bgmName' && this.sendDataInfo.detailList[this.seIndex]) {
                // 表格字段赋值
                for (let key in val) {
                    this.sendDataInfo.detailList[this.seIndex][key] = val[key];
                }
                this.$nextTick(() => {
                    this.tableNextFocus(this.fField, this.seIndex);
                });
            } else {
                // 表单字段赋值
                for (let key in val) {
                    this.sendDataInfo[key] = val[key];
                }
                this.$nextTick(() => {
                    this.nextFocus(this.seIndex);
                });
            }
            
            this.DialogVisible = false;
        },
        // 获取检索方案宽度
        getSeWidth(width) {
            this.seWidth = width + "%";
        },
        // 获取检索方案标题
        getSearchName(title) {
            this.seTitle = title;
        },
        // 处理选择变化
        handleSelectionChange(rows) {
            this.selectedRow = rows;
        },
        // 初始化操作框
        initActionBox(val) {
            // 重置表单数据
            if (val === 'sendDataInfo') {
                // 重置主要表单数据
                this.sendDataInfo = {
                    detailList: []
                };
                // 重置左侧表格搜索
                // 重置选中状态
                this.selectedDetailsIndex = 0;
                this.selectedRow = [];
                // 通知父组件关闭抽屉
                this.$emit('drawerCancel');
            }
        },
        // 获取值
        getValue(val, type, fieldType, formatterContent) {
            // 实现获取值逻辑
            return val;
        },

    },
    created() {
        this.imgurl();
        // 设置表格高度
        this.mxHeight = window.innerHeight - 300;
    },
    mounted() {
        this.GSPgoodsQueryOcrResultList();
    }
};
</script>

<style scoped>
.form_codition {
    width: 193px;
}
.left_table{
    height: calc(100vh - 50px);

}
.table_content_box {
    padding: 10px;
}

#operateBtn {
    margin-bottom: 5px;
    margin-top: 5px;
}

.baseTable {
    margin-top: 10px;
}

/* 隐藏 el-radio 中的数字 */
::v-deep .el-radio__label {
  display: none;
}

/* 调整单选按钮的位置 */
::v-deep .el-radio {
  margin-right: 0;
}
.rightHeight{
    max-height: 200px;
}
.rightHeight1{
    max-height: calc(100vh - 150px);
}
</style>